import { Burger } from '../core'

export default {
  burger: undefined,

  init() {
    /* Burger */
    let obj = this
    obj.burger = new Burger('.burger', {
      onToggle: function() {
        if (obj.burger.isExpanded) {
          $('body').addClass('--menu-open')
        } else {
          $('body').removeClass('--menu-open')
        }
      },
    })
  },

  minimize(){
    /* Minimize Header on mobile */
    $(window).on( "scroll", function() {
      if ( $(window).scrollTop() >= 1 ) {
          $('header.header').addClass("header--minimized")
      }else{
          $('header.header').removeClass("header--minimized")
      }
    })
  }
}
